<div class="dark-mode-container flex flex-wrap gap-4">
  <div
    [ngClass]="{
      'border-2': isDarkTheme
    }"
    class="rounded-full px-6 py-3 bg-default text-secondary border-primary flex justify-between items-center gap-2 max-w-fit cursor-pointer hover:opacity-70 duration-200"
    (click)="toggleDarkTheme(true)"
  >
    <span class="material-symbols-outlined"> dark_mode </span>
    <span class="font-bold text-sm">Dark</span>
  </div>
  <div
    [ngClass]="{
      'border-2': !isDarkTheme
    }"
    class="rounded-full px-6 py-3 bg-default text-secondary border-primary flex justify-between items-center gap-2 max-w-fit cursor-pointer hover:opacity-70 duration-200"
    (click)="toggleDarkTheme(false)"
  >
    <span class="material-symbols-outlined"> light_mode </span>
    <span class="font-bold text-sm">Light</span>
  </div>
</div>
